import { render, staticRenderFns } from "./FindId.vue?vue&type=template&id=2f5052b2&scoped=true&"
import script from "./FindId.vue?vue&type=script&lang=js&"
export * from "./FindId.vue?vue&type=script&lang=js&"
import style0 from "./FindId.vue?vue&type=style&index=0&id=2f5052b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5052b2",
  null
  
)

export default component.exports